export class TheatreError extends Error {}

export class InvalidArgumentError extends TheatreError {}
